import {Component, Input} from '@angular/core';
import {ILeadMappedItem} from '@app/logic/leads/interfaces/i.lead.mapped';
import {NavigationService} from '@app/core/services/navigation/navigation.service';
import { ENQUIRY_ORIGIN_ENUM, IIdAndLabelDto, ILotDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {LotsLogicService} from '@app/logic/lots';
import {CbDialogService} from '@app/shared/components/dialog/cb-dialog.service';
import {LeadEnquiryOriginEditDialogComponent} from './lead-enquiry-origin-edit-dialog/lead-enquiry-origin-edit-dialog.component';
import {LeadLogicService} from '@app/logic/leads';
import { take } from 'rxjs';

@Component({
    selector: 'cb-lead-enquiry-origin-card',
    templateUrl: './lead-enquiry-origin-card.component.html',
    styleUrls: ['./lead-enquiry-origin-card.component.scss'],
    standalone: false
})
export class LeadEnquiryOriginCardComponent {
    @Input() public mappedItem: ILeadMappedItem;
    @Input() public canEdit: boolean;
    public ENQUIRY_ORIGIN_ENUM = ENQUIRY_ORIGIN_ENUM;
    public showHomes: ILotDto[];
    public showHomeToDisplay: IIdAndLabelDto;

    constructor(
        private readonly navigationService: NavigationService,
        private readonly lotsLogicService: LotsLogicService,
        public readonly cbDialog: CbDialogService,
        private readonly leadLogicService: LeadLogicService
    ) {
        this.lotsLogicService.getShowhomes().pipe(take(1)).subscribe(showHomes => {
            this.showHomes = showHomes;
            this.showHomeToDisplay = this.showHomes.find(sh => sh.id === this.mappedItem.showHomeId) as unknown as IIdAndLabelDto;
        });
    }


    public getReferredByName(): string {
        if (!this.mappedItem.referredById) {
            return;
        }
        return this.mappedItem.referredBy;
    }

    public viewReferrer(id: string, event: MouseEvent): void {
        this.navigationService.navigate([`/contacts/${id}/summary`], event);
    }

    public getDisplayShowhomeSelect = (): boolean => {
        return this.mappedItem.showHomeId > 0;
    };

    public editEnquiryOriginDetails(event: Event): void {
        if (!this.canEdit) { return; }
        this.cbDialog.open(LeadEnquiryOriginEditDialogComponent, {
            data: {
                mappedItem: this.mappedItem.$clone()
            },
            minWidth: 600
        })
            .afterClosed()
            .pipe(take(1)).subscribe(result => {
                if (result) {
                    this.mappedItem = this.leadLogicService.$createMappedItem(result);
                }
            });
    }
}
